import { render, staticRenderFns } from "./TPPRecordsStep.vue?vue&type=template&id=474b36ee&scoped=true"
import script from "./TPPRecordsStep.vue?vue&type=script&lang=js"
export * from "./TPPRecordsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b36ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474b36ee')) {
      api.createRecord('474b36ee', component.options)
    } else {
      api.reload('474b36ee', component.options)
    }
    module.hot.accept("./TPPRecordsStep.vue?vue&type=template&id=474b36ee&scoped=true", function () {
      api.rerender('474b36ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/storeVisitReport/components/Step/TPPRecordsStep.vue"
export default component.exports